<template>
  <v-card tile>
    <v-card-title class="pl-0">
      <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>系统公告
      <v-spacer />
      <v-text-field dense rounded hide-details label="搜索关键词" single-line v-model="queryParam.searchValue" outlined prepend-inner-icon="mdi-magnify" @keydown.native="onSearchValueKeydown" />
    </v-card-title>
    <v-card-text style="min-height:600px;">
      <v-data-table dense :headers="headers" :items="dataList" hide-default-footer disable-sort>
        <template v-slot:item.sn="{ item }">{{dataList.indexOf(item)+1}}</template>
        <template v-slot:item.ct="{ item }">{{ Utility.fmtDt(item.ct) }}</template>
        <template v-slot:item.title="{ item,value }">
          <a @click="onDetail(item)">{{value}}</a>
        </template>
        <template v-slot:item.readFlag="{ item }">{{ item.readFlag?'已读':'未读' }}</template>
      </v-data-table>
      <v-pagination v-if="pagination.num>1" v-model="pagination.index" :length="pagination.num" :total-visible="pagination.size" @input="onPage" />
    </v-card-text>

    <v-dialog v-model="detailVisible" max-width="650" scrollable>
      <v-card min-height="350">
        <v-card-title>
          <div>公告详情</div>
          <v-spacer />
          <v-btn icon @click="detailVisible=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="2">发布时间:</v-col>
            <v-col cols="10">{{Utility.fmtDt(detailData.ct)}}</v-col>
            <v-col cols="2">标题:</v-col>
            <v-col cols="10">{{detailData.title}}</v-col>
            <v-col cols="12">内容:</v-col>
            <v-col cols="12">{{detailData.content}}</v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-card>
</template>
<script>
/* eslint-disable no-console */
import { getNotice, getNoticeDetail } from '@/plugins/api';
export default {
  data () {
    return {
      headers: [
        { text: '#', value: 'sn' },
        { text: '标题', value: 'title' },
        { text: '发布时间', value: 'ct' },
        { text: '状态', value: 'readFlag' },
      ],
      dataList: [],
      pagination: { index: 1, size: 10, num: 0, total: 0 },
      queryParam: { searchValue: '' },

      detailVisible: false, //弹框
      detailData: {}
    }
  },
  methods: {
    dataQuery (param) {
      getNotice(param).then(res => {
        this.dataList = res.data;
        this.pagination = res.pagination;
      })
    },
    onPage () {
      let param = { ...this.queryParam, pagination: { index: this.pagination.index, size: this.pagination.size } }
      this.dataQuery(param);
    },
    onSearch () {
      let param = { ...this.queryParam, pagination: { index: 1, size: this.pagination.size } }
      this.dataQuery(param);
    },

    onDetail (item) {
      getNoticeDetail({ id: item.id }).then(res => {
        let index = this.dataList.indexOf(item);
        this.$set(this.dataList[index], 'readFlag', true);
        this.detailVisible = true
        let d = res.data
        this.detailData = d;
      })
    },
    onSearchValueKeydown (e) {
      if (e.keyCode == 13) this.onSearch()
    }
  },
  created () {
    this.onSearch()
  }
}
</script>